let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("iL76j")]).then(() => parcelRequire('iz6z2'));